import React, { useContext, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import MedicalTableInit from './tables/MedicalTableInit'
import { LoginContext } from '../../reactcontext/ReactContext'

const MedicalLanding = () => {
  const { loginInfo } = useContext(LoginContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (!loginInfo.login) {
      navigate('/passport_exp')
    }
  }, [loginInfo, navigate])

  return (
    <div className='w-full flex h-full flex-col items-center justify-between relative gap-3'>
      <div className='self-start'>
        <Link to={'/dashboard'} className='text-yellow-700'>
          Dashboard
        </Link>
        {' > '} Medical
      </div>

      <div className='w-full p-2 flex items-center flex-col justify-center h-full gap-3'>
        <h1 className='text-xl font-semibold'>Medical Certificates</h1>
        <MedicalTableInit />
      </div>
    </div>
  )
}

export default MedicalLanding
